import {
  Product,
  useEventProducts,
} from 'organization/Event/Products/EventProductsProvider'
import {ListProduct} from 'organization/Event/Products/ListProduct'
import React from 'react'
import {Pagination} from '@mui/material'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

export function ProductsListing(props: {
  editProduct: (product: Product) => void
  toggleShowModal: () => void
}) {
  const {editProduct, toggleShowModal} = props
  const {t} = useI18n()

  const {products, totalPages, page, changePage} = useEventProducts()

  return (
    <div className="col-xxl-12">
      <div className="create__event-area">
        <div className="body__card-wrapper">
          <div className="attendant__wrapper mb-35">
            <ButtonsHolder>
              <div>
                <h3>{t('orgProducts.title')}</h3>
              </div>
              <button className={'input__btn'} onClick={toggleShowModal}>
                {t('orgProducts.add')}
              </button>
            </ButtonsHolder>

            <table>
              <thead>
                <tr>
                  <CenteredTH>{t('orgProducts.colNo')}</CenteredTH>
                  <CenteredTH>{t('orgProducts.colName')}</CenteredTH>
                  <CenteredTH>{t('orgProducts.colPrice')}</CenteredTH>
                  <CenteredTH>{t('orgProducts.colSales')}</CenteredTH>
                  <CenteredTH>{t('orgProducts.colStatus')}</CenteredTH>
                  <CenteredTH>{/* ACTIONS */}</CenteredTH>
                </tr>
              </thead>
              <tbody>
                {products.length === 0 && (
                  <tr>
                    <td colSpan={6}>{t('orgProducts.empty')}</td>
                  </tr>
                )}
                {products.map((product, index) => {
                  return (
                    <ListProduct
                      product={product}
                      index={index}
                      onEdit={editProduct}
                    />
                  )
                })}
              </tbody>
            </table>

            <PaginationHolder>
              <Pagination
                count={totalPages}
                shape="rounded"
                page={page}
                onChange={changePage}
              />
            </PaginationHolder>
          </div>
        </div>
      </div>
    </div>
  )
}

const PaginationHolder = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
`

const ButtonsHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const CenteredTH = styled.th`
  text-align: center;
`
